import React from "react";
import "./SmsPhonePreview.css"; // we will add CSS next

const SmsPhonePreview = ({ message = "" }) => {
  return (
    <div className="sms-phone-frame">
      <div className="sms-phone-notch"></div>

      <div className="sms-phone-screen">

        {/* Top Header */}
        <div className="sms-phone-topbar">
          <div className="sms-phone-signal"></div>
          <div className="sms-phone-time">9:41</div>
          <div className="sms-phone-battery"></div>
        </div>

        {/* Chat Body */}
        <div className="sms-chat-container">
          <div className="sms-bubble">
            {message.trim() ? (
              message.split("\n").map((line, i) => (
                <div key={i}>{line}</div>
              ))
            ) : (
              <span className="text-muted">Your message preview will appear here...</span>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default SmsPhonePreview;
